module.exports = __webpack_public_path__ + "img/entrance_resume_colors_lowerlayer.68cc0d14.png";